// https://lincolnprofilev9.cms.dealer.com/lincoln-corsair-PHEV.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						page: {
							pageName: 'research models:why buy:lincoln corsair',
							siteSection: 'research models',
							hierarchy: 'research models:why buy',
							pageNameNoVehicle: 'research models:why buy'
						},
						onclick: {
							onclick:
								'research models:why buy:content:photo click',
							onclickLinkName:
								'research models:why buy:content:action'
						},
						vehicle: {
							modelYear: '2023',
							nameplate: 'lincoln corsair'
						}
					}
				})
			}
		]
	}
};
